"use strict";

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.parse = parse, exports.Parser = void 0;
/**
* @module radspec/parser
*/

/**
* A token.
* @typedef {Object} Token
* @property {string} type The token type
* @property {*?} value The value of the token
*/

/**
* An AST node.
* @typedef {Object} Node
* @property {string} type The node type
*/

/**
* An AST.
* @typedef {Object} AST
* @property {string} type
* @property {Array<Node>} body The AST nodes
*/

/**
* Enum for parser state.
*
* @readonly
* @enum {string}
*/

var PARSER_STATE = {
  OK: "OK",
  ERROR: "ERROR"
};
/**
* Parses a token list into an AST.
*
* @class Parser
* @param {Array<Token>} tokens
* @property {string} state The state of the parser (`OK` or `ERROR`)
* @property {Array<Token>} tokens
* @property {number} cursor
*/

var Parser = /*#__PURE__*/function () {
  function Parser(tokens) {
    _classCallCheck(this, Parser);

    this.state = PARSER_STATE.OK, this.tokens = tokens, this.cursor = 0;
  }
  /**
  * Get the current token and increase the cursor by 1
  *
  * @return {Token}
  */


  _createClass(Parser, [{
    key: "consume",
    value: function consume() {
      return this.cursor++, this.tokens[this.cursor - 1];
    }
    /**
    * Get the previous token.
    *
    * @return {Token}
    */

  }, {
    key: "previous",
    value: function previous() {
      return this.tokens[this.cursor - 1];
    }
    /**
    * Get the token under the cursor without consuming it.
    *
    * @return {Token}
    */

  }, {
    key: "peek",
    value: function peek() {
      return this.tokens[this.cursor];
    }
    /**
    * Checks if the type of the next token matches any of the expected types.
    *
    * Increases the cursor by 1 if the token matches.
    *
    * @param {...string} expected The expected types
    * @return {boolean} True if the next token matches, otherwise false
    */

  }, {
    key: "matches",
    value: function matches() {
      if (this.eof()) return !1;

      for (var _len = arguments.length, expected = new Array(_len), _key = 0; _key < _len; _key++) {
        expected[_key] = arguments[_key];
      }

      for (var _i = 0, _expected = expected; _i < _expected.length; _i++) {
        var type = _expected[_i];
        if (this.peek().type === type) return this.cursor++, !0;
      }

      return !1;
    }
    /**
    * Try to parse comparison operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "comparison",
    value: function comparison(astBody) {
      var node = this.addition(astBody);

      for (; this.matches("GREATER", "GREATER_EQUAL", "LESS", "LESS_EQUAL", "EQUAL_EQUAL", "BANG_EQUAL");) {
        var operator = this.previous().type,
            right = this.addition(astBody);
        node = {
          type: "ComparisonExpression",
          operator: operator,
          left: node,
          right: right
        };
      }

      return this.matches("QUESTION_MARK") && (node = {
        type: "TernaryExpression",
        predicate: node,
        left: this.comparison(astBody)
      }, !this.matches("COLON") && this.report("Half-baked ternary (expected colon)"), node.right = this.comparison(astBody)), this.matches("DOUBLE_VERTICAL_BAR") && (node = {
        left: node,
        right: this.comparison(),
        type: "DefaultExpression"
      }), node;
    }
    /**
    * Try to parse arithmetic operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "addition",
    value: function addition(astBody) {
      var node = this.multiplication(astBody);

      for (; this.matches("MINUS", "PLUS");) {
        var operator = this.previous().type,
            right = this.multiplication(astBody);
        node = {
          type: "BinaryExpression",
          operator: operator,
          left: node,
          right: right
        };
      }

      return node;
    }
    /**
    * Try to parse binary operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "multiplication",
    value: function multiplication(astBody) {
      var node = this.power(astBody);

      for (; this.matches("SLASH", "STAR", "MODULO");) {
        var operator = this.previous().type,
            right = this.power(astBody);
        node = {
          type: "BinaryExpression",
          operator: operator,
          left: node,
          right: right
        };
      }

      return node;
    }
    /**
    * Try to parse exponential operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "power",
    value: function power(astBody) {
      var node = this.unary(astBody);

      for (; this.matches("POWER");) {
        var operator = this.previous().type,
            right = this.unary(astBody);
        node = {
          type: "BinaryExpression",
          operator: operator,
          left: node,
          right: right
        };
      }

      return node;
    }
    /**
    * Try to parse unary operators.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "unary",
    value: function unary(astBody) {
      if (this.matches("BANG", "MINUS")) {
        var operator = this.previous().type,
            right = this.unary(astBody);
        return {
          type: "UnaryExpression",
          operator: operator,
          right: right
        };
      }

      return this.identifier(astBody);
    }
    /**
    * Try to parse identifiers and call expressions.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "identifier",
    value: function identifier(astBody) {
      var node;

      if (this.matches("IDENTIFIER") && (node = {
        type: "Identifier",
        value: this.previous().value
      }), !node) {
        var previousNode = astBody.length && astBody[astBody.length - 1];
        previousNode && ("Identifier" === previousNode.type || "GroupedExpression" === previousNode.type || "CallExpression" === previousNode.type) && (node = previousNode, astBody.pop());
      }

      if (node) {
        for (; this.matches("DOT");) {
          var property = this.consume().value;
          node = {
            type: "PropertyAccessExpression",
            target: node,
            property: property
          };
        }

        return this.matches("LEFT_PAREN") && (node = {
          type: "CallExpression",
          target: node.target,
          callee: node.property,
          inputs: this.functionInputs(astBody),
          outputs: []
        }, this.eof() && this.report("Unterminated call expression"), node.outputs = this.typeList()), node;
      }

      return this.helper(astBody);
    }
    /**
    * Try to parse helper functions
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "helper",
    value: function helper(astBody) {
      if (this.matches("AT")) {
        var identifier = this.consume(),
            name = identifier.value;
        "IDENTIFIER" !== identifier.type && this.report("Invalid helper function name '".concat(name, "' provided after @"));
        var node = {
          type: "HelperFunction",
          name: name
        };
        return this.matches("LEFT_PAREN") ? node.inputs = this.functionInputs(astBody) : this.report("Expected '(' for executing helper function"), node;
      }

      return this.primary(astBody);
    }
    /**
    * Try to parse primaries (literals).
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "primary",
    value: function primary() {
      if (this.matches("NUMBER", "STRING", "HEXADECIMAL", "BOOLEAN")) {
        var type = {
          NUMBER: "NumberLiteral",
          STRING: "StringLiteral",
          HEXADECIMAL: "BytesLiteral",
          BOOLEAN: "BoolLiteral"
        }[this.previous().type];
        return {
          type: type,
          value: this.previous().value
        };
      }

      if (this.matches("LEFT_PAREN")) {
        var expression;

        do {
          // Keep munching expressions in the context of the current expression
          expression = this.comparison(expression ? [expression] : []);
        } while (!this.eof() && !this.matches("RIGHT_PAREN"));

        return this.eof() && this.report("Unterminated grouping"), {
          type: "GroupedExpression",
          body: expression
        };
      }

      this.report("Unknown token \"".concat(this.consume().type, "\""));
    }
    /**
    * Try to parse a type.
    *
    * @return {string} The type
    */

  }, {
    key: "type",
    value: function type() {
      return this.matches("COLON") || "TYPE" === this.peek().type || this.report("Expected a type, got \"".concat(this.peek().type, "\"")), this.consume().value;
    }
    /**
    * Try to parse a type list.
    *
    * @return {Array<string>} The list of types
    */

  }, {
    key: "typeList",
    value: function typeList() {
      // We just have a single type
      if (this.matches("COLON") || "TYPE" === this.peek().type && "LEFT_PAREN" === this.peek().type || this.report("Expected a type or a list of types, got \"".concat(this.peek().type, "\"")), !this.matches("LEFT_PAREN")) return [{
        type: this.consume().value,
        selected: !0
      }];
      var typeList = [];

      for (; !this.eof() && !this.matches("RIGHT_PAREN");) {
        // Check if the type is preceded by a < to denote
        // that this is the type of the return value we want.
        var selected = this.matches("LESS");
        "TYPE" === !this.peek().type && this.report("Unexpected identifier in type list, expected type, got \"".concat(this.peek().type, "\"")), typeList.push({
          type: this.consume().value,
          selected: selected
        }), selected && !this.matches("GREATER") && this.report("Unclosed selected type"), this.matches("COMMA") || "RIGHT_PAREN" === this.peek().type || this.report("Undelimited parameter type (expected comma delimiter or closing brace)");
      }

      this.eof() && this.report("Unclosed type list"); // Verify that at least one type in the type list has been selected
      // as the type of the return value.
      //
      // If no type has been selected, and the number of types in the type
      // list is exactly 1, then we assume that that type should be
      // marked as selected.

      var hasSelectedTypeInList = !!typeList.find(function (item) {
        return item.selected;
      });
      return hasSelectedTypeInList || 1 !== typeList.length ? !hasSelectedTypeInList && this.report("Type list has no selected type") : typeList[0].selected = !0, typeList;
    }
    /**
    * Try to parse function arguments.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Array<Node>}
    */

  }, {
    key: "functionInputs",
    value: function functionInputs(astBody) {
      var inputs = [];

      for (; !this.eof() && !this.matches("RIGHT_PAREN");) {
        var input = this.comparison(astBody);
        input.type ? this.matches("COLON") && this.report("Unexpected type (already inferred type of parameter)") : input.type = this.type(), inputs.push(input), this.matches("COMMA") || "RIGHT_PAREN" === this.peek().type || this.report("Undelimited parameter type (expected comma delimiter or closing brace)");
      }

      return inputs;
    }
    /**
    * Walk all possible paths and try to parse a single node
    * from the list of tokens.
    *
    * @param  {Array<Node>} astBody Subtree of AST being walked
    * @return {Node}
    */

  }, {
    key: "walk",
    value: function walk(astBody) {
      var token = this.peek();
      if ("MONOLOGUE" === token.type) return {
        type: "MonologueStatement",
        value: this.consume().value
      };

      if ("TICK" === token.type) {
        var node = {
          type: "ExpressionStatement",
          body: []
        };

        for (this.matches("TICK"); !this.eof() && "TICK" !== this.peek().type;) {
          node.body.push(this.walk(node.body));
        }

        return this.eof() && this.report("Unterminated expression"), this.matches("TICK"), node;
      }

      return this.comparison(astBody);
    }
    /**
    * Walks the token list and returns an AST.
    *
    * @return {AST} The AST
    */

  }, {
    key: "parse",
    value: function () {
      var _parse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ast;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ast = {
                  type: "Program",
                  body: []
                };

                for (; !this.eof();) {
                  ast.body.push(this.walk(ast.body));
                }

                return _context.abrupt("return", this.state === PARSER_STATE.ERROR ? (console.error("Errors encountered while parsing source"), ast) : ast);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function parse() {
        return _parse.apply(this, arguments);
      }

      return parse;
    }()
    /**
    * Returns true if we've reached the end of the token list, otherwise false.
    *
    * @return {boolean}
    */

  }, {
    key: "eof",
    value: function eof() {
      return this.cursor >= this.tokens.length;
    }
    /**
    * Prints an error with location information to `stderr`
    * and sets the parser state to `PARSER_STATE.ERROR`
    *
    * @param {string} error
    * @return {void}
    */

  }, {
    key: "report",
    value: function report(error) {
      this.state = PARSER_STATE.ERROR, console.error("Error (".concat(this.cursor, "): ").concat(error));
    }
  }]);

  return Parser;
}();
/**
* Walks token list and returns an AST.
*
* @memberof radspec/parser
* @param  {Array<Token>} tokens
* @return {AST} The AST
*/


exports.Parser = Parser;

function parse(tokens) {
  return new Parser(tokens).parse();
}